/**
 * Story List block script.
 *
 * Two responsibilities:
 *  - "Load more" toggle reveals cards beyond index 3 that ship hidden.
 *  - Initial visible cards (the first 3) get a staggered fade-up on scroll-in.
 *
 * The reveal is capped at the visible cards because hidden cards have no
 * sensible pre-state — they animate themselves naturally via the load-more
 * handler unhiding them.
 */

import { revealStagger } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-story-list').forEach((section) => {
		const cardsWrap = section.querySelector('.container > div');
		if (cardsWrap) {
			revealStagger(cardsWrap, {
				childSelector: ':scope > article:not(.hidden)',
				stagger: 0.09,
				duration: 0.5,
			});
		}
	});

	document.querySelectorAll('.js-story-list-load-more').forEach((btn) => {
		btn.addEventListener('click', () => {
			const section = btn.closest('.rmh-story-list');
			if (!section) {
				return;
			}

			section.querySelectorAll('[data-story-list-hidden]').forEach((card) => {
				card.classList.remove('hidden');
				card.removeAttribute('data-story-list-hidden');
			});

			const buttonWrapper = btn.closest('div');
			if (buttonWrapper) {
				buttonWrapper.remove();
			}
		});
	});
});
